import { render, staticRenderFns } from "./AzForm.vue?vue&type=template&id=7280b91c&"
import script from "./AzForm.vue?vue&type=script&lang=js&"
export * from "./AzForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports